import {
  SubscriptionStateItem,
  SubscriptionCountyItem,
  PayPerLeadSubscription,
} from "@containers/PayPerLead/interface";
import { County } from "@shared/models";

export enum StateIdType {
  Nationwide = "nationwide",
}

export interface StateOption {
  label: string;
  value: number | StateIdType;
  abbreviation: string;
  counties: CountyById;
}

export interface CountyOption {
  value: number;
  label: string;
}

export type StatesById = Record<number | string, StateOption>;
export type CountyById = Record<number, CountyOption>;
export type LeadPriceByCounty = Record<number, number>;
export type LeadPriceByState = Record<number | string, number>;

export interface SubscriptionWithCallbackPayload {
  subscription: PayPerLeadSubscription;
  cancellation_reason?: { cancellation_reason: string; cancellation_reason_other?: string };
  paymentSourceId?: string;
  callback: (id: number) => void;
  onFailed?: (id: number, error?: { message: string }) => void;
}

export interface SubscriptionIdsWithCallbackPayload {
  ids: number[];
  callback: (paymentAmount: number) => void;
}

export interface SetDiscountPayload {
  id: number;
  coupon: string | null;
}

export interface UpdateSubscriptionBillingPayload {
  id: number;
  renew: boolean;
}

export interface UpdateSubscriptionBillingPayloadWithCallback extends UpdateSubscriptionBillingPayload {
  callback: () => void;
}

export interface FetchStateLeadPricePayload {
  stateId: number | StateIdType;
}

export interface FetchFilterOptionsPayload {
  is_inactive: boolean;
  is_full_range: boolean;
  is_non_renewing?: boolean;
}

export interface FetchStateLeadPriceResponse {
  stateId: number | StateIdType;
  price: number;
}

export interface SubscriptionsListQuery {
  isActive?: boolean;
  showItems?: boolean;
  order?: keyof PayPerLeadSubscription;
  direction?: "asc" | "desc";
}

export interface SubscriptionsListResponse {
  items: PayPerLeadSubscription[];
  total: number;
}

export interface FetchCountyOptionsPayload {
  stateId: number | StateIdType;
}

export interface CacheCountyOptionsResult extends FetchCountyOptionsPayload {
  counties: CountyById;
}

export interface FetchCountyPricePayload {
  stateId: number;
  countyId: number;
}
export interface CacheCountyPriceResult extends FetchCountyPricePayload {
  price: number;
}

export interface CountyListResponse {
  items: County[];
  total: number;
}

export interface GetSubscriptionDetailsPayload {
  id: number;
  draftItems: boolean;
}

export interface AddSubscriptionCountyPayload {
  countyId: number;
  to: SubscriptionStateItem;
}

export interface DeleteSubscriptionCountyPayload {
  from: SubscriptionStateItem;
  county: SubscriptionCountyItem;
}

export interface UpdateSubscriptionItemPayload {
  original: SubscriptionStateItem;
  update: Partial<SubscriptionStateItem>;
}

export interface UpdateSubscriptionCountyPayload {
  from: SubscriptionStateItem;
  county: SubscriptionCountyItem;
  totalLeads?: number;
}
